import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Scissors, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const StylesPage = () => {
  const [images, setImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('');

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const [imgRes, catRes] = await Promise.all([
        axios.get(`${API}/gallery`),
        axios.get(`${API}/gallery/categories`),
      ]);
      setImages(imgRes.data);
      setCategories(catRes.data);
      if (catRes.data.length > 0) setActiveCategory(catRes.data[0].slug);
    } catch (error) {
      toast.error('Errore nel caricamento');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-12 w-12 animate-spin text-accent" />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-20 container mx-auto px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Stili e Tagli</h1>
          <p className="text-muted-foreground text-lg">Scopri i nostri tagli più richiesti</p>
        </div>

        {categories.length > 0 && activeCategory && (
          <Tabs value={activeCategory} onValueChange={setActiveCategory} className="w-full">
            <TabsList className="flex flex-wrap gap-1 h-auto mb-8 bg-transparent justify-center">
              {categories.map((cat) => {
                const count = images.filter(i => i.category === cat.slug).length;
                return (
                  <TabsTrigger
                    key={cat.id}
                    value={cat.slug}
                    className="py-2 px-4 data-[state=active]:bg-accent data-[state=active]:text-accent-foreground rounded-full border"
                  >
                    <span>{cat.name}</span>
                    <span className="text-xs opacity-70 ml-1">({count})</span>
                  </TabsTrigger>
                );
              })}
            </TabsList>

            {categories.map((cat) => {
              const catImages = images.filter(i => i.category === cat.slug);
              return (
                <TabsContent key={cat.id} value={cat.slug} className="mt-0">
                  {catImages.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                      {catImages.map((image) => (
                        <Card key={image.id} className="card-elegant overflow-hidden group cursor-pointer">
                          <div className="relative aspect-[4/5] overflow-hidden">
                            <img
                              src={image.url}
                              alt={image.alt || 'Style'}
                              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
                            {image.alt && (
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <p className="text-sm font-medium">{image.alt}</p>
                              </div>
                            )}
                          </div>
                        </Card>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-16">
                      <Scissors className="h-12 w-12 text-muted-foreground mx-auto mb-3 opacity-50" />
                      <p className="text-muted-foreground">Prossimamente nuovi stili!</p>
                    </div>
                  )}
                </TabsContent>
              );
            })}
          </Tabs>
        )}
      </div>
    </div>
  );
};

export default StylesPage;
